import React from 'react';
import { Edit2 } from 'react-feather';
import FocusAreaAccordion from './FocusAreaAccordion';
import ComparisonIngredientCard from './ComparisonIngredientCard';

const MobileFormulaComparison = ({
  comparison,
  ingredients,
  focusAreaIcons,
  currentPrice,
  newPrice,
  t,
  onKeepCurrent,
  onUseNew,
  onEdit,
  isUpdating,
  isUpdateBlocked,
}) => {
  const currentById = new Map(comparison.ingredients.map((item) => [Number(item.ingredient_id), item]));
  const newById = new Map(ingredients.map((item) => [Number(item.ingredient_id), item]));
  const ids = [...new Set([...currentById.keys(), ...newById.keys()])];

  return (
    <div className="lg:t-hidden">
      <div className="t-grid t-grid-cols-2 t-gap-4 t-border-t-2 t-border-quiz-teal t-bg-navy/5 t-p-4">
        {[
          { title: 'QuizComparison_CurrentTitle', price: currentPrice, focus: comparison.focusArea },
          { title: 'QuizComparison_NewTitle', price: newPrice, focus: comparison.focusArea2 },
        ].map((formula) => (
          <div key={formula.title} className="t-min-w-0">
            <h2 className="t-m-0 t-font-serif t-text-xl t-leading-tight t-text-navy">{t(formula.title)}</h2>
            <p className="t-my-3 t-break-words t-text-base t-font-semibold t-text-navy">{formula.price}</p>
            <FocusAreaAccordion
              focusArea={formula.focus}
              focusAreaIcons={focusAreaIcons}
              collapsedCount={2}
            />
          </div>
        ))}
      </div>
      <div className="t-mt-5 t-pt-2 t-pb-1">
        <div className="t-flex t-items-center t-gap-3 t-px-3 t-pb-1">
          <div className="t-w-2.5" />
          <div className="t-flex-1" />
          <div className="t-flex t-items-center t-gap-2 t-flex-shrink-0 t-text-[10px] t-font-bold t-text-navy/40 t-uppercase t-tracking-wider">
            <span className="t-w-[64px] t-text-right">{t('QuizComparison_CurrentColumn')}</span>
            <span className="t-w-[64px] t-text-right">{t('QuizComparison_NewColumn')}</span>
            <span className="t-w-2.5" />
          </div>
        </div>
        {ids.map((id, index) => (
          <ComparisonIngredientCard
            key={id}
            current={currentById.get(id)}
            next={newById.get(id)}
            index={index}
            defaultOpen={index === 0}
          />
        ))}
      </div>
      <div className="t-mt-5 t-flex t-flex-col t-gap-3">
        <button
          type="button"
          onClick={onEdit}
          disabled={isUpdating}
          className="t-inline-flex t-min-h-[44px] t-items-center t-justify-center t-gap-2 t-rounded-lg t-border t-border-quiz-teal t-bg-white t-px-4 t-text-sm t-font-semibold t-text-quiz-teal disabled:t-opacity-50"
        >
          <Edit2 size={16} aria-hidden="true" />
          {t('QuizComparison_Edit')}
        </button>
        <button
          type="button"
          onClick={onUseNew}
          disabled={isUpdateBlocked}
          className="t-min-h-[44px] t-rounded-lg t-border t-border-quiz-teal t-bg-quiz-teal t-px-4 t-text-sm t-font-semibold t-text-white disabled:t-opacity-50"
        >
          {isUpdating ? t('QuizComparison_Saving') : t('QuizComparison_UseNew')}
        </button>
        <button
          type="button"
          onClick={onKeepCurrent}
          disabled={isUpdating}
          className="t-min-h-[44px] t-bg-transparent t-px-4 t-text-sm t-font-semibold t-text-quiz-teal disabled:t-opacity-50"
        >
          {t('QuizComparison_KeepCurrent')}
        </button>
      </div>
    </div>
  );
};

export default MobileFormulaComparison;
